// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"58c6bf73","746":"20638dee"}[chunkId] + ".chunk.js";
};